<template>
  <div class="std-background">
    <v-card width="500" class="mx-auto my-3">
      <div class="std-title std-title--divider">
        <h2><span class="std-title--small">Book a </span><br/>'Basic Bekam' session</h2>
        <h3 class="std-title--small">Screening assessment</h3>
      </div>
      <div class="checklist__form" :class="{'pa-4': $vuetify.breakpoint.smAndDown}">
        <p class="mb-0">Firstly, we would like to ensure that you are eligible for bekam. Please tick any statement that is true.</p>
        <p color="primaryLight" class="mb-0 mt-3"><v-icon size="18" color="primaryLight">mdi-help-circle</v-icon> You may want to read our <router-link to="/privacy-policy">privacy policy</router-link> first.</p>
        <v-container fluid>
          <v-checkbox v-model="representativeBooking" label="Are you booking for someone else?"></v-checkbox>
          <p v-if="representativeBooking">Please answer the remaining statements on behalf of the person you're booking for.</p>
          <v-checkbox
            v-for="data in checklistData"
            v-model="checklistResult"
            :label="representativeBooking ? data.representativeLabel : data.selfLabel"
            :value="data.id"
            :key="data.id">
          </v-checkbox>
          <hr class="std-section--divider">
          <p class="mb-0 mt-3 primaryLight--text">Please choose one option only for the following</p>
          <v-radio-group v-model="diabetesChecklistResult">
            <v-radio
              class="mb-5"
              v-for="data in diabetesChecklist"
              :label="representativeBooking ? data.representativeLabel : data.selfLabel"
              :value="data.id"
              :key="data.id">
            </v-radio>
          </v-radio-group>
          <hr class="std-section--divider">
          <p class="mb-0 mt-3 primaryLight--text">Please choose one option only for the following</p>
          <v-radio-group v-model="hypertensionChecklistResult">
            <v-radio
              class="mb-5"
              v-for="data in hypertensionChecklist"
              :label="representativeBooking ? data.representativeLabel : data.selfLabel"
              :value="data.id"
              :key="data.id">
            </v-radio>
          </v-radio-group>
          <hr class="std-section--divider">
          <v-checkbox v-model="acknowledgement" label="I hereby declare that the information entered are true and correct"></v-checkbox>
        </v-container>
        <div class="text-right mb-10">
          <v-btn depressed :disabled="!acknowledgement" color="primaryLight" class="white--text" :href="resultsPageLink" target="_blank" @click="redirectUser()">Next</v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'Checklist',
    data() {
      return {
        representativeBooking: false,
        checklistData: [
          { id: 'gender', selfLabel: 'I am female', representativeLabel: 'She is female' },
          { id: 'menstruation', selfLabel: 'I am not having my menstruation', representativeLabel: 'She is not having her menstruation' },
          { id: 'bloodClottingMedication', selfLabel: 'I am not on anti-blood clotting medication (pencair darah) like aspirin or warfarin', representativeLabel: 'She is not on anti-blood clotting medication (pencair darah) like aspirin or warfarin' },
          { id: 'pregnancy', selfLabel: 'I am not pregnant', representativeLabel: 'She is not pregnant' },
        ],
        diabetesChecklist: [
          { id: 'diabetes', selfLabel: 'I am not diabetic (high blood sugar)', representativeLabel: 'She is not diabetic (high blood sugar)' },
          { id: 'consult_diabetes', selfLabel: 'I am diabetic and on medication', representativeLabel: 'She is diabetic and on medication' },
          { id: 'danger_diabetes', selfLabel: 'I am diabetic but not on any medication', representativeLabel: 'She is diabetic but not on any medication' }
        ],
        hypertensionChecklist: [
          { id: 'hypertension', selfLabel: "I don't have hypertension (high blood pressure)", representativeLabel: "She doesn't have hypertension (high blood pressure)" },
          { id: 'consult_hypertension', selfLabel: 'I have hypertension and on medication', representativeLabel: 'She has hypertension and on medication' },
          { id: 'danger_hypertension', selfLabel: 'I have hypertension but not on any medication', representativeLabel: 'She has hypertension but not on any medication' }
        ],
        checklistResult: [],
        diabetesChecklistResult: null,
        hypertensionChecklistResult: null,
        acknowledgement: false,
        resultsPageLink: ''
      }
    },
    methods: {
      redirectUser() {
        if (this.diabetesChecklistResult == 'diabetes' || this.diabetesChecklistResult == 'consult_diabetes') this.checklistResult.push(this.diabetesChecklistResult)
        if (this.hypertensionChecklistResult == 'hypertension' || this.hypertensionChecklistResult == 'consult_hypertension') this.checklistResult.push(this.hypertensionChecklistResult)
        this.$store.commit('setCheckedResults', { representativeBooking: this.representativeBooking, criteriaPassed: this.checklistResult })
        if (this.checklistResult.length == 6) {
          const anyConsultation = this.checklistResult.filter(result => result.includes('consult'))
          if (anyConsultation && anyConsultation.length > 0) this.$router.push('/consultation')
          else this.$router.push('/booking')
        } else this.$router.push('/results?status=red')
      }
    }
  }
</script>
